import * as D from 'io-ts/lib/Decoder'
import { enum_, withDefault } from 'decode/util'

export enum PassTierType {
    SELECT = 'select',
    INPUT = 'input',
    DISPLAY_ONLY = 'display-only',
    CHECKBOX = 'checkbox',
}

const PassTierFormFieldDecoder = D.intersection(
    D.type({
        _id: D.string,
        type: enum_(PassTierType.SELECT, PassTierType.INPUT, PassTierType.DISPLAY_ONLY, PassTierType.CHECKBOX),
    }),
    D.partial({
        options: D.array(D.string),
        required: D.boolean,
        imgUrl: D.string,
        placeholder: D.string,
        label: D.string,
        validationType: D.string,
        validations: D.array(
            D.type({
                type: D.string,
                params: D.UnknownArray,
            }),
        ),
    }),
)

const PassTierFormGroupDecoder = D.intersection(
    D.type({
        _id: D.string,
        title: D.string,
        fields: D.array(PassTierFormFieldDecoder),
    }),
    D.partial({
        instructions: D.partial({
            heading: D.string,
            listItems: D.array(D.string),
        }),
    }),
)

export const PassTierDecoder = D.type({
    _id: D.string,
    amount: D.number,
    title: D.string,
    descItems: D.array(D.string),
    formGroups: D.array(PassTierFormGroupDecoder),
    serviceFee: withDefault(0, D.number),
    isSoldOut: withDefault(false, D.boolean),
})

export const PassTierRemainingPassesDecoder = D.type({
    passTier: D.string,
    remaining: D.nullable(D.number),
})

export interface PassTier extends D.TypeOf<typeof PassTierDecoder> {}
export interface PassTierFormField extends D.TypeOf<typeof PassTierFormFieldDecoder> {}
export interface PassTierFormGroup extends D.TypeOf<typeof PassTierFormGroupDecoder> {}
export interface PassTierRemainingPasses extends D.TypeOf<typeof PassTierRemainingPassesDecoder> {}
